/** Map capabilities that expose Google location / address search in the top bar. */
const LOCATION_ADDRESS_SEARCH_SCREENS = new Set([
  'light',
  'transformer',
  'transformers',
  'wifi',
  'aqi',
  'notifications',
  'cameras_video',
  'tilt_monitoring',
  'planning',
  'work_order',
]);

const POWER_QUALITY_SCREENS = new Set([
  'power_quality_sustained',
  'power_quality_momentary',
  'power_quality_voltage',
]);

/**
 * These screens are configured as search_only in top-bar config, but
 * they still need location search (Google + coordinates) in the dropdown.
 */
const SEARCH_ONLY_LOCATION_ENABLED_SCREENS = new Set(['planning']);

/**
 * True when the current top-bar capability supports location address search
 * (coordinate search is only offered on these screens).
 */
export function supportsLocationAddressSearch(
  mainScreen: string,
  searchOnly = false
): boolean {
  if (!mainScreen) {
    return false;
  }
  if (
    searchOnly &&
    !SEARCH_ONLY_LOCATION_ENABLED_SCREENS.has(mainScreen)
  ) {
    return false;
  }
  if (LOCATION_ADDRESS_SEARCH_SCREENS.has(mainScreen)) {
    return true;
  }
  return POWER_QUALITY_SCREENS.has(mainScreen);
}
